/**
 * staleTime tiers (ms). Hooks pick a tier explicitly per the locked caching decision, rather
 * than each guessing its own number.
 */
export const STALE_TIME = {
  /** Reference/config data that rarely changes (bundle catalog, surfaces). Long. */
  reference: 1000 * 60 * 30, // 30 min
  /** Operational data touched during normal use (lists, workspace state). Short. */
  operational: 1000 * 30, // 30 s
  /** The caller's own profile — bundle/verification changes must surface fast. Near-zero. */
  ownProfile: 0,
} as const;

/** Default tier for queries that don't specify one — short/operational. */
export const DEFAULT_STALE_TIME = STALE_TIME.operational;

/** How long unused cache entries survive before garbage collection. */
export const DEFAULT_GC_TIME = 1000 * 60 * 5; // 5 min
